import React, { useState } from 'react';
import axios, { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import { FaEnvelope, FaLock } from 'react-icons/fa';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from 'react-router-dom';


const Login: React.FC = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const res = await axios.post('https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net/api/userAuth/adminlogin', {
        email: form.email,
        password: form.password,
      });

      if (res.data?.token) {
        sessionStorage.setItem('email', form.email);
        localStorage.setItem('jwt', res.data.token);
        localStorage.setItem('customerId', res.data.customerId);
        localStorage.setItem('role', 'admin'); // 👈 Set role as admin

        toast.success('✅ Logged in!');
        navigate('/admin'); // redirect to admin dashboard
      } else {
        toast.error('⚠️ No token received');
      }
    } catch (err) {
      const error = err as AxiosError;
      console.error('❌ Login error:', error.message);

      if (error.response?.status === 401) {
        alert('❌ Invalid credentials');
      } else if (error.code === 'ERR_NETWORK') {
        alert('📡 Network error');
      } else {
        alert('⚠️ Something went wrong during login.');
      }
    }
  };



  return (
    <div className="auth-bg d-flex justify-content-center align-items-center min-vh-100" style={{
      background: "linear-gradient(to right, #f3f3f3, #d2f1f2)",
      backgroundImage: `url('/images/ppbg.jpg')`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat'
    }}>
      <div className="card shadow-lg p-5 rounded-4 bg-white" style={{ width: '100%', maxWidth: '450px' }}>
        <div className="text-center mb-4">
          <img src="/images/fhome-logo.jpg" alt="Logo" style={{ height: 60, width: 80 }} />
          <h4 className="mt-3 fw-bold">Login to Your Account</h4>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label><FaEnvelope className="me-2" /> Email</label>
            <input type="email" name="email" className="form-control rounded-3" onChange={handleChange} required />
          </div>
          <div className="form-group mb-4">
            <label><FaLock className="me-2" /> Password</label>
            <input type="password" name="password" className="form-control rounded-3" onChange={handleChange} required />
          </div>
          <div>

            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              pauseOnHover
              draggable
              theme="light"
            />
          </div>
          <button type="submit" className="btn btn-primary w-100 py-2 rounded-3">Login</button>
        </form>
        <p className="text-center mt-3 mb-0">
          Don’t have an account? <Link to="/registration" className="text-decoration-none">Register</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;

